import { render } from "./SideBarStyle.vue?vue&type=template&id=00ef53ac"
import script from "./SideBarStyle.vue?vue&type=script&lang=js"
export * from "./SideBarStyle.vue?vue&type=script&lang=js"

import "../../../assets/css/ambient.css?vue&type=style&index=0&lang=css&external"
import "../../../assets/css/sidebar.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__